export const googleReviews = [
  {
    name: 'Ayşe K.',
    rating: 5,
    text: 'Çok ilgili ve profesyonel bir ekip. Gözlük seçiminde bana çok yardımcı oldular, tam istediğim modeli buldum.',
    textEn: 'Very attentive and professional team. They helped me a lot with frame selection and I found exactly what I wanted.',
    date: '2025-11',
    source: 'google',
  },
  {
    name: 'Mehmet Y.',
    rating: 5,
    text: 'Ray-Ban güneş gözlüğümü buradan aldım. Orijinal ürün, uygun fiyat ve hızlı teslimat. Kesinlikle tavsiye ederim.',
    textEn: 'I bought my Ray-Ban sunglasses here. Original product, fair price and fast delivery. Highly recommended.',
    date: '2025-10',
    source: 'google',
  },
  {
    name: 'Zeynep A.',
    rating: 5,
    text: 'Progresif lens için geldim, muayene çok detaylıydı. Gözlüğüm mükemmel oturuyor, çok memnunum.',
    textEn: 'I came for progressive lenses and the examination was very thorough. My glasses fit perfectly.',
    date: '2025-09',
    source: 'google',
  },
  {
    name: 'Elif S.',
    rating: 5,
    text: 'Çocuğum için gözlük aldık. Sabırla ilgilendiler, çocuk dostu bir ortam. Teşekkürler SAN Optik!',
    textEn: 'We bought glasses for our child. They were patient and the environment was child-friendly. Thank you!',
    date: '2025-07',
    source: 'google',
  },
  {
    name: 'Burak T.',
    rating: 5,
    text: 'Gözlüğümün sapı kırıldı, ücretsiz tamir ettiler. Satış sonrası hizmet gerçekten çok iyi.',
    textEn: 'My temple broke and they repaired it for free. The after-sales service is truly excellent.',
    date: '2025-06',
    source: 'google',
  },
  {
    name: 'Selin M.',
    rating: 5,
    text: 'Marka çeşitliliği çok geniş, personel çok bilgili. Gözlük seçerken kendimi güvende hissettim.',
    textEn: 'Great variety of brands and very knowledgeable staff. I felt confident choosing my glasses.',
    date: '2025-05',
    source: 'google',
  },
];

export const reviews = googleReviews;
